// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bonus-offer-row .bonus-container {
  width: 100%;
}
.bonus-offer-row p.expiry-date {
  font-size: 0.75rem;
  font-weight: 400;
  margin: 0 !important;
}
.bonus-offer-row::ng-deep ion-button {
  min-width: 6rem;
  margin: 0;
}
.bonus-offer-row .bonus-offer-button {
  flex-direction: column;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/rewards/bonuses/bonus-offers/bonus-offers.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR;AAGI;EACI,kBAAA;EACA,gBAAA;EACA,oBAAA;AADR;AAII;EACI,eAAA;EACA,SAAA;AAFR;AAKI;EACI,sBAAA;EACA,uBAAA;AAHR","sourcesContent":[".bonus-offer-row {\r\n    .bonus-container {\r\n        width: 100%;\r\n    }\r\n\r\n    p.expiry-date {\r\n        font-size: .75rem;\r\n        font-weight: 400;\r\n        margin: 0 !important;\r\n    }\r\n\r\n    &::ng-deep ion-button {\r\n        min-width: 6rem;\r\n        margin: 0;\r\n    }\r\n\r\n    .bonus-offer-button {\r\n        flex-direction: column;\r\n        justify-content: center;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
